import { getQueryStringValue } from 'utilities/browser';
import { utagLinkEmailSignup } from 'features/tealium';
import { domReady, initRegularFormSubmissionActivity, initBlockEnterKeyForDisabledButton } from 'utilities/dom';
import { postUnsubscribeAll } from 'features/account/api';

window.addEventListener('load', () => {

	const isFromFooter = getQueryStringValue('isFromFooter') || null;

	if (
		document.querySelector('#subscribeNowThankYou')
		|| (isFromFooter && !document.querySelector('#ProfileExists'))
	) {

		utagLinkEmailSignup(window.lp.pageData.utagEmailAddress);

	}

	document.getElementById('showCountryField').addEventListener('click', (e) => {

		e.preventDefault();
		const countryField = document.querySelector(e.target.dataset.show);

		if (countryField) {

			countryField.classList.toggle('hidden');

			e.target.setAttribute('aria-expanded', !countryField.classList.contains('hidden'));

		}

	});

});

function initUnsubscribeFromAll () {

	const form = document.querySelector('#unSubscribeAllForm');
	const submitButton = form?.querySelector('#unsubscribeAllButton');
	const successMessage = form?.querySelector('#unsubscribeAllSuccessMessage');
	const errorMessage = form?.querySelector('#unsubscribeAllErrorMessage');

	form?.addEventListener('submit', (e) => {

		e.preventDefault();
		if ($(form).valid()) {

			const email = new FormData(form).get('unsubscribe_email');

			submitButton?.setAttribute('aria-disabled', 'true');
			submitButton?.classList.add('loading');
			successMessage?.classList.add('hidden');
			errorMessage?.classList.add('hidden');

			postUnsubscribeAll(email.trim().toLowerCase()).then(() => {

				successMessage?.classList.remove('hidden');
				errorMessage?.classList.add('hidden');

			}).catch(() => {

				errorMessage?.classList.remove('hidden');
				successMessage?.classList.add('hidden');

			}).finally(() => {

				submitButton?.removeAttribute('aria-disabled');
				submitButton?.classList.remove('loading');

			});

		}

	});

	window.initFormValidation(true, form);

}

domReady(() => {

	const subscribeNowBtn = document.getElementById('subscribeBtn');

	initRegularFormSubmissionActivity(subscribeNowBtn);
	initBlockEnterKeyForDisabledButton(subscribeNowBtn);

	initUnsubscribeFromAll();

});
